import { useLayoutEffect, useRef } from 'react';

/** How long answer taps wait after what is shown moved (LOOPB-867 review). */
export const LIVE_TAP_SETTLE_MS = 500;

/**
 * Whether a tap now is one the person aimed at what is on screen: false for `ms` after `shownKey` changes (a new
 * question, or the sheet height that follows it), true otherwise and on first mount. The live sheet grows from
 * "Get ready" to 640 at question 1 and Close/Share move ~330 px up; a tap aimed at them must not land as an answer,
 * nor one aimed at question 1 as an answer to question 2. Read it in a handler, never while rendering.
 */
export function useTapSettle(shownKey: string, ms = LIVE_TAP_SETTLE_MS): () => boolean {
  const shown = useRef(shownKey);
  const changedAt = useRef<number | null>(null);
  // Layout, not passive: set in the same commit that draws the new question, before any tap can reach it.
  useLayoutEffect(() => {
    if (shown.current === shownKey) return;
    shown.current = shownKey;
    changedAt.current = Date.now();
  }, [shownKey]);
  return () => changedAt.current === null || Date.now() - changedAt.current >= ms;
}
